import React from "react";
import styled from "styled-components";
import titleImg from "../../../assets/imgs/zhongcai_title.png"
import {TextField} from "@material-ui/core";
import {useForm} from "react-hook-form";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {useWait} from "../../../utils/wait_fn";
import {HttpServer} from "../../../net/http_server";
import {LoadingModal} from "../../../model/http_loading";
import {SuccessWidget} from "../arbitration/success_widget";

export const InputModel: React.FC<{ onDismiss?: () => void, callBack: Function, title: string, tis?: boolean, buttonTest:string }> = ({
                                                                                                                      onDismiss,
                                                                                                                      callBack,
                                                                                                                      title,
                                                                                                                                          buttonTest,
                                                                                                                      tis = true
                                                                                                                  }) => {
    const {register, errors, handleSubmit} = useForm();
    let name = 'number'
    const {data, status, request} = useWait<any>(callBack);

    return (
        <LoadingModal status={status} data={data} onDismiss={onDismiss} success={SuccessWidget}>
            <InputStyle>
                <h2>{title}</h2>
                <div className={'box'}>
                    <h3>Amount or roles</h3>
                    <form>
                        <TextField name={name}
                                   error={Boolean(errors[name])}
                                   placeholder={'Input'}
                                   unselectable={'off'}
                                   fullWidth={true}
                                   inputRef={register({
                                       required: 'no Enter the number is dame',
                                   })}
                        />
                    </form>
                    {tis && <h4>Each Assessment role requires a stake of <span>2,000 Nsure to be locked.</span></h4>}

                    <div className={'bottons'}>
                        <ButtonWidget onClick={onDismiss} size={{y: 50, x: 10}} text={'Cancel'} type={'border'}/>
                        <ButtonWidget size={{y: 50, x: 10}}
                                      onClick={handleSubmit((data: any) => request(data.number))}
                                      text={buttonTest}
                                      type={'color'}/>
                    </div>
                </div>
            </InputStyle>
        </LoadingModal>

    );
}


const InputStyle = styled.div`
  background-color: white;
  border-radius: 15px;
  width: 350px;

  h2 {
    background-image: url("${titleImg}");
    background-size: 100% 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-repeat: no-repeat;
    color: #270D4F;
  }

  .box {
    padding: 20px 15px;
    box-sizing: border-box;

    h3 {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 10px;
    }

    form {

      border: 1px solid #999999;

      .MuiInputBase-input {
        color: black;
        padding: 10px 10px;
        height: 1em;
        line-height: 1;

        .MuiInputBase-input {

        }

        &::-webkit-input-placeholder {
          text-align: start;
        }
      }

      .MuiInput-underline:before {
        display: none;
      }

      .MuiInput-underline:after {
        display: none;
      }
    }

    h4 {
      text-align: center;
      height: 17px;
      font-size: 12px;
      font-weight: 500;
      color: #666666;
      line-height: 17px;
      margin-top: 20px;
      //margin: 20px 0;

      span {
        color: #6236FF;
      }
    }

    .bottons {
      margin-top: 20px;
      display: flex;
      justify-content: space-around;
    }
  }

`


